import { Box, Spinner } from '@chakra-ui/react'
import { BgColors } from 'commons/design-system/tokens'

export const PageLoaderCentered = () => {
	return (
		<Box
			w='100%'
			h='100%'
			display='flex'
			justifyContent='center'
			alignItems={{ base: 'flex-start', md: 'center' }}
			position={'fixed'}
			top={{ base: 24, md: 0 }}
			left={0}
		>
			<Spinner color={BgColors.OPPOSITE_Z3} />
		</Box>
	)
}
